import styled from 'styled-components';

export const UpsellCalloutWrapper = styled.div`
  margin-top: 16px;
`;
